import type { SeverityLevel } from "./types"
import { formatLogData, toLogRecord } from "./log-data"

export interface LogOptions {
  level?: SeverityLevel
  message: string
  data?: unknown
  stack?: string
  source?: string
  timestamp?: number
  console?: boolean
  category?: string
}

export function addBreadcrumb({
  level = "info",
  message,
  data,
  stack = "",
  source,
  timestamp = Date.now(),
  console: toConsole = true,
  category = "log",
}: LogOptions) {
  const record = toLogRecord(data)
  const serializedData = formatLogData(data)

  if (level === "error" || level === "fatal") {
    console.error(
      `[${category.toUpperCase()}]`,
      message,
      serializedData ?? "",
      record ? { data: record, stack, source, timestamp } : { stack, source, timestamp }
    )
  } else if (level === "warning") {
    console.warn(
      `[${category.toUpperCase()}]`,
      message,
      serializedData ?? "",
      record ? { data: record, stack, source, timestamp } : { stack, source, timestamp }
    )
  } else if (toConsole || level === "info") {
    console.log(
      `[${category.toUpperCase()}]`,
      message,
      serializedData ?? "",
      record ? { data: record, stack, source, timestamp } : { stack, source, timestamp }
    )
  }
}

export function log({
  level = "info",
  message,
  data,
  stack = "",
  source,
  timestamp = Date.now(),
  console: toConsole = true,
  category = "log",
}: LogOptions) {
  const record = toLogRecord(data)
  const serializedData = formatLogData(data)
  const label = category === "log" ? "[LOG]" : `[${category.toUpperCase()}]`

  if (level === "error" || level === "fatal") {
    console.error(
      label,
      message,
      serializedData ?? "",
      record ? { data: record, stack, source, timestamp } : { stack, source, timestamp }
    )
  } else if (level === "warning") {
    console.warn(
      label,
      message,
      serializedData ?? "",
      record ? { data: record, stack, source, timestamp } : { stack, source, timestamp }
    )
  } else if (toConsole || level === "info") {
    console.log(
      label,
      message,
      serializedData ?? "",
      record ? { data: record, stack, source, timestamp } : { stack, source, timestamp }
    )
  }
}
